"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChannelCustomizationToggle = exports.Channel = exports.ChannelOption = exports.Check = exports.Input = exports.Channels = exports.StyledItem = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var StyledItem = _styledComponents["default"].div.withConfig({
  displayName: "ChannelPreferenceStyles__StyledItem",
  componentId: "sc-1pfz43q-0"
})(["display:flex;align-items:center;text-align-center;background:rgba(213,221,228,0.4);border-radius:15px;font-style:normal;font-weight:700;font-size:12px;line-height:16px;> div{margin-right:7.5px;}white-space:nowrap;padding:5px;margin-top:7.5px;"]);

exports.StyledItem = StyledItem;

var Channels = _styledComponents["default"].div.withConfig({
  displayName: "ChannelPreferenceStyles__Channels",
  componentId: "sc-1pfz43q-1"
})(["display:flex;width:100%;justify-content:end;"]);

exports.Channels = Channels;

var Input = _styledComponents["default"].input.withConfig({
  displayName: "ChannelPreferenceStyles__Input",
  componentId: "sc-1pfz43q-2"
})(["position:absolute;opacity:0;cursor:pointer;height:0;width:0;"]);

exports.Input = Input;

var Check = _styledComponents["default"].svg.withConfig({
  displayName: "ChannelPreferenceStyles__Check",
  componentId: "sc-1pfz43q-3"
})(["width:15px;height:15px;padding-left:3.5px;fill:white;"]);

exports.Check = Check;

var ChannelOption = _styledComponents["default"].div.withConfig({
  displayName: "ChannelPreferenceStyles__ChannelOption",
  componentId: "sc-1pfz43q-4"
})(["display:flex;width:55px;height:20px;background:transparent;border-radius:12px;border:1px solid black;whitespace:nowrap;font-style:normal;font-weight:500;font-size:10px;line-height:16px;justify-content:center;align-items:center;margin:0 3px;svg{display:normal;margin-right:3px;}"]);

exports.ChannelOption = ChannelOption;

var Channel = _styledComponents["default"].div.withConfig({
  displayName: "ChannelPreferenceStyles__Channel",
  componentId: "sc-1pfz43q-5"
})(["label{display:block;position:relative;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}", ":checked ~ ", "{background:#1e4637;color:white;border:0;}", ":checked ~ ", " > div{color:white;}"], Input, ChannelOption, Input, ChannelOption);

exports.Channel = Channel;

var ChannelCustomizationToggle = _styledComponents["default"].label.withConfig({
  displayName: "ChannelPreferenceStyles__ChannelCustomizationToggle",
  componentId: "sc-1pfz43q-6"
})(["input{display:none;opacity:0;width:0;height:0;}div{width:20px;height:20px;border:solid 1px black;border-radius:100%;margin:0 2.5px;position:static;background-color:!white;display:flex;align-items:center;}", ":checked ~ div > ", "{fill:white;}", ":checked ~ div{border:0;background-color:#1e4637;}"], Input, Check, Input);

exports.ChannelCustomizationToggle = ChannelCustomizationToggle;